interface EnvironmentConfig {
    apiGatewayBaseUrl: string;
}

const baseUrlConfig: { [key: string]: EnvironmentConfig} = {
    //All envs should be in lowercase for consistency
    development: {
        apiGatewayBaseUrl: import.meta.env.VITE_API_GATEWAY_URL || 'https://nytd.nonprod-cdhs-trails.colorado.gov', //Temporary exposed until variable groups are in place
    },
    labs: {
        apiGatewayBaseUrl: import.meta.env.VITE_API_GATEWAY_URL || 'https://nytd.nonprod-cdhs-trails.colorado.gov', 
    },
    production: {
        apiGatewayBaseUrl: import.meta.env.VITE_API_GATEWAY_URL || 'https://nytd.cdhs-trails.colorado.gov', 
    }
};

export default baseUrlConfig;